import { createFileRoute } from "@tanstack/react-router"

import { SettingsGeneralPage } from "@/pages/settings/general"

export const Route = createFileRoute("/_authenticated/settings/general")({
  component: SettingsGeneralPage,
})
